<template>
    <div class="wl-container">
        <div class="course-content" v-loading="loading">
            <el-tabs type="border-card" v-model="activeName" @tab-click="onSizeChange(8)">
                <el-tab-pane :label="$t('myFafourite')" name="myCollect"></el-tab-pane>
                <el-tab-pane :label="$t('myCourses')" name="myCourse"></el-tab-pane>
            </el-tabs>
            <div class="search-content">
                <el-input :placeholder="$t('please_input')" v-model="searchInput">
                    <el-button slot="append" icon="el-icon-search" type="primary" @click="getTable">{{ $t('btn_search2') }}</el-button>
                </el-input>
            </div>
            <div class="course-list" v-if="courseList.length">
                <div class="course-item-outer" v-for="item in courseList" :key="item.courseId">
                    <div class="course-item" @click="goDetail(item)">
                        <div class="isNew" v-if="item.newCourseFlag">New</div>
                        <img :src="item.coverImgUrl" alt="" class="course-pic" />
                        <div class="title-row">
                            <el-tooltip :content="item.title" :disabled="item.title.length <= 24">
                                <div class="course-title">
                                    {{ item.title }}
                                </div>
                            </el-tooltip>
                            <div class="course-price" :class="item.chargeType === 'FREE' ? 'free' : ''">
                                {{ item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
                            </div>
                        </div>
                        <div class="course-item-child">
                            <div class="course-time">{{ $t('kee_duration') }}: {{ durationTrans(item.sumDurationFormat) }}</div>
                            <div
                                class="course-collect"
                                :style="{ visibility: activeName === 'myCollect' ? 'visible' : 'hidden' }"
                                @click.stop="removeCollect(item)"
                            >
                                <img src="@/assets/img/icon-remove.svg" class="collect-icon" width="100%" />
                                <span>{{ $t('kee_remove_like') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <el-row :gutter="2">
          <el-col :span="6" v-for="item in courseList" :key="item.courseId">
            <div class="course-list-item" @click="goDetail(item)">
              <div class="isNew" v-if="item.newCourseFlag">New</div>
              <img :src="item.coverImgUrl" alt="" class="course-pic">
              <div class="course-item-child margin-bottom-30">
                <div class="course-title">{{item.title}} {{ item.status == 'WITHDRAW' ? `(${$t('kee_WITHDRAW')})` : '' }}</div>
                <div class="course-price" :class="item.chargeType === 'FREE' ? 'free' : ''">{{item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge')}}</div>
              </div>
              <div class="course-item-child">
                <div class="course-time">{{ $t('kee_duration') }}: {{durationTrans(item.sumDurationFormat)}}</div>
                <div class="course-collect" v-if="activeName === 'myCollect'" @click.stop="removeCollect(item)">
                  <img src="@/assets/img/icon-remove.svg" class="collect-icon" width="100%" />
                  <span>{{ $t('kee_remove_like') }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row> -->
            </div>
            <el-empty
                class="course-list"
                v-else
                :description="activeName == 'myCollect' ? $t('kee_my_empty') : $t('kee_my_empty1')"
            ></el-empty>
            <el-pagination
                class="wl-pagination"
                :current-page="pagination.pageNum"
                :page-size="pagination.pageSize"
                @size-change="onSizeChange"
                @current-change="onCurrentPageChange"
                :page-sizes="[8, 16, 24, 48, 96]"
                layout="prev, pager, next, sizes, total"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import Tooltip from '@/components/common/Tooltip.vue'

export default {
    name: 'myCourse',
    components: { Tooltip },
    data() {
        return {
            searchInput: '',
            activeName: 'myCollect',
            courseList: [],
            pagination: {
                pageNum: 1,
                pageSize: 8,
                total: 0
            },
            loading: false
        }
    },
    mounted() {
        this.getTable()
    },
    methods: {
        durationTrans(v) {
            return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
        },
        getTable() {
            this.loading = true
            let param = {
                fuzzy: this.searchInput,
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize
            }
            if (this.activeName === 'myCourse') {
                param.viewFlag = 1
            } else {
                param.collectFlag = 1
            }
            API.insights.queryCourseInfo(param).then((res) => {
                if (res.code === '1') {
                    this.courseList = res.data.records || []
                    this.pagination.total = res.data.total
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        goDetail(item) {
            if (item.status == 'WITHDRAW') {
                // 已下架的课程不让点进详情页
                this.$message.error($t('kee_offline_detail_disabled'))
                return
            }
            this.$router.push({ name: 'courseDetail', query: { courseId: item.courseId } })
        },
        removeCollect(item) {
            let param = {
                courseId: item.courseId,
                flag: 0
            }
            API.insights.updateCollectFlagRecord(param).then((res) => {
                if (res.code === '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getTable()
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getTable()
        },
        onSizeChange(current) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = current
            this.getTable()
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        })
    }
}
</script>
<style scoped>
.wl-container {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 15px;
}
.course-content {
    /* height: 100%; */
    background-color: white;
    border-radius: 8px;
    position: relative;
}
.search-content {
    position: absolute;
    display: flex;
    right: 20px;
    top: 7px;
}
::v-deep .el-tabs__header {
    padding: 0 !important;
    border-bottom: none;
    background-color: #e3e4e6;
}
::v-deep .el-tabs--border-card {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: none;
    overflow: hidden;
    box-shadow: none;
}
::v-deep .el-tabs__nav {
    height: 43px;
}
::v-deep .course-content .el-tabs__item {
    color: #333333 !important;
    font-size: 13px !important;
    font-weight: bold !important;
    height: 43px;
    line-height: 43px;
    padding: 0 20px !important;
    border: none !important;
}
::v-deep .el-tabs__item.is-active {
    color: #3879eb !important;
    border-top: 3px solid #3879eb !important;
}
::v-deep .el-tabs__content {
    padding: 0;
}
::v-deep .el-input-group > .el-input__inner {
    height: 28px;
}
::v-deep .el-input-group__append button.el-button {
    border-color: #3879eb;
    background-color: #3879eb;
    color: white;
    height: 28px;
}
.wl-green-small {
    height: 28px;
    margin-left: 10px;
}

.course-list {
    /* padding: 15PX 20PX;
    height: calc(100% - 30PX - 48px);
    overflow: auto; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 20px;
    /* height: calc(100% - 95PX); */
}
.course-list.el-empty {
    flex-direction: column;
}
.course-list .course-item-outer {
    width: calc(25% - 20px);
    margin: 0 10px 10px 10px;
}
.course-list .course-item-outer .course-item {
    padding: 25px 20px;
    border: 1px solid #cfcfcf;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s linear;
    text-align: center;
}
.course-list .course-item-outer .course-item:hover {
    box-shadow: 1px 1px 10px 10px #efeff5;
}
.course-list .course-item-outer .course-item .isNew {
    position: absolute;
    padding: 4px 7px;
    right: 0;
    top: 0;
    color: white;
    background-color: #00b8f5;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
}


.course-list .course-item-outer .course-item .title-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100px;
}
.course-list .course-item-outer .course-item .title-row .course-price {
    font-size: 14px;
}
.course-list .course-item-outer .course-item .course-item-child {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.course-list-item {
    padding: 20px;
    border: 1px solid #cfcfcf;
    border-radius: 8px;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    width: fit-content;
}
.course-list-item:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 1s;
}
.isNew {
    position: absolute;
    padding: 4px 7px;
    right: 0;
    top: 0;
    color: white;
    background-color: #f2b000;
    border-bottom-left-radius: 8px;
}

.margin-bottom-30 {
    margin-bottom: 30px;
}
.course-item-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.course-title {
    color: #00338d;
    font-size: 18px;
    font-weight: bold;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.2em;
    max-height: 2.4em;
}
.course-price {
    font-size: 18px;
    color: #fd349c;
}
.free {
    color: #00c0ae;
}
.course-time {
    color: #636363;
    font-size: 14px;
    margin-left: 10px;
}
.course-collect {
    color: #333333;
    font-size: 14px;
    display: flex;
    cursor: pointer;
}
.collect-icon {
    height: 16px;
    width: 16px;
    margin-right: 5px;
    margin-top: 1px;
}
.course-pic {
    height: 380px;
    width: 330px;
    border-radius: 8px;
    margin-bottom: 10px;
}
.wl-pagination {
    padding-right: 20px !important;
}
</style>
